<template>
  <div class="list" v-if="stores.length > -1">
    <div :class="{list__gradient: showGradient}"></div>
    <div class="list__header">{{ listHeaderNo }} {{ listHeaderSuffix }}</div>
    <div id="items" class="list__items">
      <div class="list__item"
           :class="{'list__item--selected': selectedMarker && store.uuid === selectedMarker.uuid}"
           v-for="(store, i) in stores"
           @click="listClick(store, i)">
        <div class="list__name">
          <div class="list__type" :class="{'list__type--brand': store.monobrand && (store.monobrand === '1' || store.monobrand === true)}"></div>
          <div class="list__details">{{ store.name }}</div>
        </div>
        <div class="list__matrix">
          <div class="list__address">{{ store.address }}, {{ store.city }}</div>
          <div class="list__distance" v-if="store.distance">{{ store.distance.replace('.', ',') }} {{ $t('matrix') }}</div>
        </div>
        <div class="list__ipad">
          <div class="list__show">{{ $t('showIpad') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/bus'
  import geodist from 'geodist'

  export default {
    name: 'List',
    data: () => ({
      service: null,
      showGradient: false,
      showMaximum: 50,
      stores: [],
      timer: null
    }),
    computed: {
      bounds () {
        return this.$store.state.bounds
      },
      listHeaderNo () {
        return `${this.stores.length >= this.showMaximum ? '+' : ''}${this.stores.length}`
      },
      listHeaderSuffix () {
        return `${this.$t((this.stores.length > 1 ? 'listHeaderMult' : 'listHeader'))}`
      },
      selectedMarker () {
        return this.$store.state.selectedMarker
      },
      position () {
        return this.$store.state.currentPosition
      }
    },
    methods: {
      calculateDistance () {
        if (!this.position) return
        const maxdist = 20000

        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          const dests = this.stores
            .slice(0, 10)
            .filter(marker => marker.geodist < maxdist)
            .map(marker => new google.maps.LatLng(marker.latitude, marker.longitude))

          this.getDistanceService(dests)
            .then(rows => {
              for (const [index] of this.stores.entries()) {
                setTimeout(() => {
                  if (this.stores[index]) {
                    const distanceText = rows[index] && rows[index].status === 'OK' && rows[index].distance.value < maxdist
                      ? (rows[index].distance.value / 1000).toFixed(1)
                      : (this.stores[index].geodist < maxdist
                        ? (this.stores[index].geodist * 1.2 / 1000).toFixed(1)
                        : `+${maxdist / 1000}`)
                    this.$set(this.stores[index], 'distance', distanceText)
                  }
                }, 100 * index)
              }
            })
            .catch(() => {
              // Silent fail
            })
        }, 1000)
      },
      getDistanceService (destinations) {
        return new Promise((resolve, reject) => {
          if (destinations.length === 0) return resolve({})

          this.service.getDistanceMatrix({
            origins: [new google.maps.LatLng(this.position.latitude, this.position.longitude)],
            destinations,
            travelMode: 'WALKING'
          }, (response, status) => {
            if (status !== 'OK') reject()
            resolve(response.rows[0].elements)
          })
        })
      },
      filterSeen (markers) {
        if (!this.bounds) return

        this.stores = markers
          .filter(marker => {
            if (this.position) {
              const origin = {lat: this.position.latitude, lon: this.position.longitude}
              const dist = {lat: marker.latitude, lon: marker.longitude}
              marker.geodist = geodist(origin, dist, {unit: 'meters'})
            }

            const { latitude, longitude } = marker
            const latLng = new google.maps.LatLng(latitude, longitude)
            return this.bounds.contains(latLng)
          })
          .sort((a, b) => {
            if (a.monobrand === b.monobrand) {
              return (a.geodist < b.geodist ? -1 : 1)
            }
            return (a.monobrand && (a.monobrand === '1' || a.monobrand === true) ? -1 : 1)
          }).splice(0, this.showMaximum)

        this.calculateDistance()
      },
      listClick (marker) {
        this.$store.commit('selectedMarker', marker)
        scroll(0, 0)
      }
    },
    watch: {
      stores () {
        this.$nextTick(() => {
          const el = document.getElementById('items')
          this.showGradient = el.scrollHeight > el.clientHeight
        })
      },
      position () {
        this.filterSeen(this.stores)
      }
    },
    mounted () {
      EventBus.$on('googleReady', () => {
        this.service = new google.maps.DistanceMatrixService()
      })
      EventBus.$on('markers', this.filterSeen)
    }
  }
</script>

<style scoped>
  .list {
    background: rgba(255, 255, 255, .9);
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    text-align: left;
    font-size: 0.8rem;
    line-height: 1.2rem;
    display: flex;
    flex-direction: column;
    -webkit-backdrop-filter: blur(3px);
    pointer-events: auto;
    position: relative;
    overflow: hidden;
  }
  .list__header {
    text-transform: uppercase;
    padding: 1rem 1.2rem;
    background: #FFF;
    font-size: 10px;
    letter-spacing: 2px;
  }
  .list__gradient {
    height: 30%;
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
    position: absolute;
    z-index: 5;
    bottom: 0;
    width: 100%;
    pointer-events: none;
  }
  .list__items {
    overflow-y: scroll;
  }
  .list__item {
    padding: .7rem .9rem;
    border-bottom: 1px solid #DDD;
    cursor: pointer;
  }
  .list__item--selected {
    background: #EEE;
  }
  .list__name {
    font-size: .9rem;
    display: flex;
    align-items: center;
    line-height: 1.6rem;
    flex: 1;
  }
  .list__details {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
  }
  .list__type {
    background-image: url('/static/images/types/retailer_small.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 18px;
    width: 12px;
    height: 18px;
    margin-right: 8px;
  }
  .list__type--brand {
    background-image: url('/static/images/types/brand.png');
  }
  .list__matrix {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
  }
  .list__address {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .list__address, .list__distance {
    white-space: nowrap;
  }
  .list__ipad {
    display: none;
  }
  .list__show {
    padding-bottom: .1rem;
    border-bottom: 1px solid #000;
  }
  .list__distance {
    font-size: 11px;
    -webkit-animation: fadein .4s; /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein .4s; /* Firefox < 16 */
    -ms-animation: fadein .4s; /* Internet Explorer */
    -o-animation: fadein .4s; /* Opera < 12.1 */
    animation: fadein .4s;
  }
  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  @media only screen and (max-device-width: 768px) {
    .list__ipad {
      display: flex;
      justify-content: space-between;
      padding: 1rem 0 .4rem;
    }
    .list {
      margin-bottom: 20px;
    }
    .list__header {
      text-align: center;
    }
  }
</style>




// WEBPACK FOOTER //
// List.vue?4536a60a